import BaseModal from 'components/BaseModal'
import React from 'react'
import { AutoComplete, AutoCompleteDataType } from 'scenes/Dashboard/components/Inputs/Select'
import { AutoCompleteOption } from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { OrganizationLocator } from 'scenes/Dashboard/data/organizations/types'

import { Button, CircularProgress, createStyles, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class AddOrganizationModal extends React.Component<
  AddOrganizationModalProps & WithStyles<typeof styles>,
  AddOrganizationModalState
> {
  readonly state = {
    organizationValue: '' as any,
  }

  handleInputChange = (option: AutoCompleteOption) => {
    this.setState({
      organizationValue: option,
    } as AddOrganizationModalState)
  }

  handleCreateOption = (inputValue: string) => ({
    value: { name: inputValue },
    display: { label: inputValue },
    isCreated: true,
  })

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { organizationValue } = this.state
    this.props.onSubmit({
      organization: (organizationValue as AutoCompleteOption).value as any,
      isCreated: (organizationValue as any).isCreated || false,
    })
    this.setState({ organizationValue: '' })
  }

  render() {
    const { classes, show, submitting, onClose } = this.props
    const { organizationValue } = this.state
    const title = <Typography variant="h5">Add organization</Typography>

    return (
      <BaseModal open={show} title={title} onClose={onClose}>
        <div className={classes.contentContainer}>
          <form onSubmit={this.handleSubmit}>
            <AutoComplete
              label="Name of the organization"
              className={classes.textField}
              value={organizationValue}
              onCreateOption={this.handleCreateOption}
              onChange={this.handleInputChange}
              disabled={submitting}
              dataType={AutoCompleteDataType.company}
              isValidNewOption={(inputValue: string) => !!inputValue}
              autoFocus
            />

            <div className={classes.submitContainer}>
              <Button
                color="secondary"
                variant="contained"
                size="medium"
                type="submit"
                disabled={submitting || !organizationValue}
              >
                Submit
                {submitting && <CircularProgress size={24} className={classes.submitProgress} />}
              </Button>
            </div>
          </form>
        </div>
      </BaseModal>
    )
  }
}

type AddOrganizationModalProps = {
  show: boolean
  submitting: boolean
  onSubmit: (data: { organization: OrganizationLocator; isCreated: boolean }) => any
  onClose: () => any
}

type AddOrganizationModalState = {
  organizationValue: AutoCompleteOption | ''
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    contentContainer: {
      width: spacing(70),
    },
    userSelect: {
      marginTop: spacing(),
    },
    textField: {
      marginTop: spacing(2),
      marginBottom: spacing(2),
    },
    submitContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: spacing(4),
      marginBottom: spacing(2),
    },
    submitProgress: {
      color: palette.secondary.main,
      position: 'absolute',
    },
    divider: {
      marginTop: spacing(3),
      marginBottom: spacing(3),
    },
  })

export default withStyles(styles)(AddOrganizationModal)
